var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoApple = function SvgLogoApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "-0.75 -0.75 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.275 13.125a4.17 4.17 0 0 1 1.988-3.506 4.31 4.31 0 0 0-3.366-1.828c-1.435-.141-2.813.843-3.525.843s-1.875-.825-3.038-.806a4.51 4.51 0 0 0-3.815 2.306c-1.622 2.813-.413 6.994 1.172 9.282.768 1.115 1.696 2.371 2.906 2.325s1.612-.75 3.019-.75 1.809.75 3.037.73 2.053-1.143 2.813-2.259a10.1 10.1 0 0 0 1.284-2.587 4.07 4.07 0 0 1-2.475-3.75m-1.922-9.037A4.7 4.7 0 0 0 15.45.722a4.7 4.7 0 0 0-3.103 1.594 4.43 4.43 0 0 0-1.097 3.309 3.92 3.92 0 0 0 3.103-1.537"
  })));
};
export default SvgLogoApple;